export default __webpack_public_path__ + "static/media/gamefi_02_3.0141c0f2.png";